/**
 * pricing.js — the single source of truth for Tadlo's own plan prices.
 *
 * WHAT BELONGS HERE
 *   Tadlo's prices, and nothing else. Competitor prices (ManyChat $15,
 *   Later $16.67, CreatorFlow $39, Linktree $5/$9) stay where they are read:
 *   they are editorial claims about someone else's pricing page, they each
 *   need their own "verified on" date, and centralising them would imply a
 *   consistency we cannot enforce.
 *
 * WHY THE HOMEPAGE STILL HOLDS LITERALS
 *   LandingPage.js is deliberately NOT refactored to read from this module.
 *   It is the only page whose content fully reaches crawlers today, it was
 *   verified byte-for-byte clean against a pre-batch build, and a
 *   find-and-replace across its hero, comparison table, three plan cards and
 *   mobile sticky bar is the highest-collateral change available. Correctness
 *   of that page beats codebase consistency.
 *
 *   The exclusion is not a blind spot: verify-prerender.js reads the
 *   PRERENDERED homepage and asserts that every price inside a .inr/.usd
 *   span matches the values below. If the literals drift from this file, the
 *   build fails. That check is how the $3-where-$5-belongs bug is prevented
 *   from returning.
 */

/** Canonical plan prices. INR is the primary market; USD is everywhere else. */
export const PLANS = {
  free: { id: "free", name: "Free", inr: 0, usd: 0 },
  creator: { id: "creator", name: "Creator", inr: 249, usd: 5 },
  pro: { id: "pro", name: "Pro", inr: 399, usd: 9 },
};

/** The cheapest PAID plan — what "starting at" and "paid entry price" mean. */
export const PAID_ENTRY = PLANS.creator;

/** Every value that may legitimately appear as a Tadlo price, by currency. */
export const ALLOWED_INR = Object.values(PLANS).map((p) => p.inr);
export const ALLOWED_USD = Object.values(PLANS).map((p) => p.usd);

export const inr = (plan) => `₹${plan.inr}`;
export const usd = (plan) => `$${plan.usd}`;
